import { FunctionComponent } from 'react';
import App from './App';

const Kesko: FunctionComponent = () => {
  return (
    <div id="calculator-app" className="App kesko-app">
      <App customer="kesko" />
    </div>
  );
};

export default Kesko;
